import { createContext } from "react";
import type { ExpandableSectionContext as ExpandableSectionContextType } from "./types";

export const ExpandableSectionContext =
  createContext<ExpandableSectionContextType>({ isExpanded: false });
